import React from "react";
import DegreeImg from "../assets/degree.png";
import ccphImg from "../assets/ccph.jpeg";
import muhsImg from "../assets/certificate.jpeg";
import "./DoctorHighlights.css";

const DoctorHighlights = () => { 
  return (
    <section className="highlights-section">
      {/* Degree Section */}
      <div className="highlight-card">
        <h3>Doctor's Qualification</h3>
        <div className="degree-image-box">
        <img src={DegreeImg} alt="Doctor's Degree" />
        </div>
        
      </div>
      
      <div className="highlight-card">
        <h3>Certificate course of predictive Homoeopathy</h3>
        <br/>
        <div className="ccph-image-box">
        <img src={ccphImg} alt="ccph" />
        </div>

        <div className="degree-image-box">
        <img src={muhsImg} alt="muhs" />
        </div>


        
      </div>

      {/* Before / After Images */}
      {/* <div className="highlight-card">
        <h3>Patient Case Transformation</h3>

        <div className="before-after-container">

          <div className="image-box">
            <h4>Before Treatment</h4>
            <img src={beforeImg} alt="Before Treatment" />
          </div>

          <div className="image-box">
            <h4>After Treatment</h4>
            <img src={afterImg} alt="After Treatment" />
          </div>

          <div className="image-box">
            <h4>After Treatment</h4>
            <img src={afterImg} alt="After Treatment" />
          </div>

        </div>
      </div> */}
    </section>
  );
};

export default DoctorHighlights;
